import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { ProfileAdvancedSearchParams } from 'src/app/profiles/search/profile-advanced-search-params.model';
import { CommitteeMemberBulkAddDto } from '../shared/dto/committee-member-bulk-add.dto';
import { CommitteeMemberProfileGridComponent } from './committee-member-profile-grid/committee-member-profile-grid.component';
import { CommitteeMemberService } from '../shared/committee-member.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-committee-member-group-add-dialog',
  templateUrl: './committee-member-group-add-dialog.component.html',
  styleUrls: ['./committee-member-group-add-dialog.component.less'],
    standalone: false
})
export class CommitteeMemberGroupAddDialogComponent implements OnInit, OnChanges {
  @ViewChild('searchGrid') committeeMemberProfileGrid: CommitteeMemberProfileGridComponent;
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();

  @Input() committeeId: number;
  @Output() addedProfiles = new EventEmitter<boolean>();
  searchParams = new ProfileAdvancedSearchParams();
  bulkAddDto = {} as CommitteeMemberBulkAddDto;
  isAdding = false;

  private _show: boolean;
  constructor(private _committeeMemberService: CommitteeMemberService, private _notificationService: NotificationService) {}

  ngOnInit(): void {
    this.bulkAddDto.StartDate = new Date();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.committeeId && this.committeeId) {
      this.bulkAddDto.CommitteeId = this.committeeId;
    }
  }

  addProfilesToCommittee() {
    this.isAdding = true;
    this.committeeMemberProfileGrid.getSelectedIds().then((selectedIds) => {
      if (!selectedIds || selectedIds.length === 0) {
        this._notificationService.translateError('committees.edit.committee-members.group-add-dialog.no-profiles-selected-error');
        this.isAdding = false;
        return;
      }
      this.bulkAddDto.ProfileIds = selectedIds;
      this._committeeMemberService
        .bulkAddCommitteeMembers(this.bulkAddDto)
        .then(() => {
          this._notificationService.translateSuccess('committees.edit.committee-members.group-add-dialog.successfully-added-profiles');
          this.addedProfiles.emit(true);
          this.close();
        })
        .catch((err) => {
          this._notificationService.httpError(err);
        })
        .finally(() => {
          this.isAdding = false;
        });
    });
  }

  open() {
    this.show = true;
  }

  close() {
    this.searchParams = new ProfileAdvancedSearchParams();
    this.bulkAddDto.ProfileIds = [];
    this.committeeMemberProfileGrid.reset();
    this.show = false;
  }
}
